/**
 * System Constants
 */
const constants = {
  SHARED_MESSAGE_AUTO_CLOSE_DELAY: 5000,
  US_COUNTRY_ID: 71,
  BREAKPOINTS: {
    small: 320,
    medium: 768,
    large: 1025,
  },
  AUTH: {
    LOGIN: 'login',
    SIGNUP: 'signup',
  },
}
/**
 * [Messages] Page Helmet
 */
const page = {
  PAGE_TITLE: 'Real Estate Auction Calendar',
  PAGE_DESCRIPTION: 'Real Estate Auction Calendar',
}

/**
 * [Messages] Errors
 */
const errors = {
  CALENDAR_ERROR_BODY:
    "We're having a technical problem. Please try again in a few minutes.",
}

/**
 * [Messages] Search Filters
 */
const filters = {
  VIEW_FILTERS: 'View Filters',
  CLEAR_FILTER: 'Clear Filters',
  ANY_LABEL: 'Any',
  FILTERS: 'Filters',
}

/**
 * [Messages] Calendar Headers
 */
const headers = {
  HEADER_LABEL_DATES_TYPE: 'Dates - Type',
  HEADER_LABEL_EVENT_NAME: 'Event Name',
  HEADER_LABEL_ASSETS_TOTAL: 'Asset Type - Total Assets',
}

/**
 * [Messages] Calendar Page
 */
const calendarTable = {
  NO_EVENT_FOUND: 'No events were found, please refine your search.',
  CALENDAR_ERROR_TITLE: 'Calendar Events',
  FETCHING_CALENDAR_EVENTS: 'Fetching Calendar Events',
  AUCTION_DATES: 'Auction Date',
  VENUE_TYPE: 'Venue Type',
  ASSET_TYPE: 'Asset Type',
  SELECT_STATE: 'Select State',
  TBD: 'TBD',
  TO_LABEL: 'to',
  AUCTION_TYPE_LIST: [
    {
      value: 'bankOwned',
      label: 'REO Bank Owned',
    },
    {
      value: 'trustee',
      label: 'Foreclosure Homes',
    },
  ],
  PAGE_SIZE: [50, 100],
}

/**
 * [Messages] Event Venue
 */
const eventVenue = {
  EVENT_VENUE_AUCTION_DATES: 'Auction Date',
  EVENT_VENUE_INFORMATION: 'Venue Information',
}

/**
 * [Messages] Auth (Signup / Login)
 */
const auth = {
  SIGN_UP_SUCCESS: 'Thank you for signing up.',
}

// Use spread operator to include the values on the exports.
module.exports = {
  ...constants,
  ...page,
  ...eventVenue,
  ...errors,
  ...filters,
  ...headers,
  ...calendarTable,
  ...auth,
}
